import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PopoverContent } from "@similarweb/ui-components";

import { SharedSearchInputStyles } from "app/pages/sales-intelligence/pages/company-analysis/styles";

export const StyledOptionsList = styled.div`
    max-height: 240px;
    min-width: 368px;
    overflow-y: auto;
`;

export const StyledPopoverContent = styled(PopoverContent)`
    padding: 0;
`;

export const StyledPopoverTrigger = styled.div`
    width: fit-content;
`;

export const StyledSearchTechnologiesContainer = styled.div`
    margin: 10px 10px 8px;
    border-bottom: 1px solid ${colorsPalettes.blue[400]};
    .SearchInput-container {
        flex-grow: 1;
    }
    .SearchInput-container .SearchInput {
        height: 34px;
        ${SharedSearchInputStyles};
    }
`;
